import { SprocketIcon } from 'foundations-assets/icons/components/SprocketIcon';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Image } from 'foundations-components/transitional/components/Image';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Tile } from 'foundations-components/transitional/components/Tile';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * **INTERNAL COMPONENT**
 * A styled box to display an account's name and id and graphic representation.
 * Internal library component used within the SourceToDestinationDiagram component.
 * Note: the default graphic is a sprocket icon but can be overridden with custom
 * illustration props or custom image props.
 * @param name - Optional account name - if not provided, the box will not render
 * @param id - Optional account id - if not provided, the box will not render
 * @param label - The label to display above the account name and id.
 * @param illustrationProps - Optional props to pass to the Illustration component: name, height, width, shape, and bordered
 * @param imageProps - Optional props to pass to the Image component: src, shape, inlineSize, minInlineSize, maxBlockSize, alt, bordered
 * @param `data-test-id` - The optional data-test-id string for testing
 */
function HubDetailsBox({
  name,
  id,
  label,
  illustrationProps,
  imageProps,
  ['data-test-id']: dataTestId
}) {
  if (!name || !id) return null;
  const generateImage = () => {
    const defaultImage = /*#__PURE__*/_jsx(View, {
      marginBlockStart: "300",
      marginInlineEnd: "500",
      children: /*#__PURE__*/_jsx(SprocketIcon, {
        size: "850",
        color: "fill-accent-orange-default"
      })
    });
    if (imageProps) {
      return /*#__PURE__*/_jsx(Image, {
        inlineSize: imageProps.inlineSize || '40px',
        minInlineSize: imageProps.minInlineSize || '40px',
        maxBlockSize: imageProps.maxBlockSize || '40px',
        marginInlineEnd: "500",
        shape: imageProps.shape,
        bordered: imageProps.bordered,
        src: imageProps.src,
        alt: imageProps.alt
      });
    } else if (illustrationProps) {
      return /*#__PURE__*/_jsx(Illustration, {
        marginInlineEnd: "500",
        name: illustrationProps.name,
        height: illustrationProps.height,
        width: illustrationProps.width,
        shape: illustrationProps.shape,
        bordered: illustrationProps.bordered
      });
    } else {
      return defaultImage;
    }
  };
  return /*#__PURE__*/_jsxs(Tile, {
    padding: "300",
    maxInlineSize: "400px",
    minInlineSize: "100px",
    maxBlockSize: "78px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    "data-test-id": dataTestId,
    children: [generateImage(), /*#__PURE__*/_jsxs("div", {
      children: [label && /*#__PURE__*/_jsx(Text, {
        typography: "heading-25",
        marginBlockEnd: "100",
        children: /*#__PURE__*/_jsx(TruncateString, {
          children: label
        })
      }), /*#__PURE__*/_jsx(Text, {
        typography: "detail-100",
        marginBlockEnd: "50",
        children: /*#__PURE__*/_jsx(TruncateString, {
          children: name
        })
      }), /*#__PURE__*/_jsx(Text, {
        typography: "detail-100",
        children: /*#__PURE__*/_jsx(TruncateString, {
          children: id
        })
      })]
    })]
  });
}
export default HubDetailsBox;